import React from "react";
import { Loader } from "components/commons";
import ShiftDetailsNonSaleTransactions from "./nonsale/nonsale-transactions";
import styles from "./cash-noncash.module.scss";
import ShiftDetailsNonCashSummary from "./noncash-summary/noncash-summary";
import ShiftDetailsCashTransaction from "./cash/cash-transactions";
import ShiftDetailsPromoSummary from "./promo-summary/promo-summary";
import ShiftDetailsExpense from "./expenses/expenses.module";
import ShiftDetailsCashOnHand from "./cash-on-hand/cash-on-hand";
import ShiftDetailsNetCashSummary from "./net-cash/net-cash";
import ShiftDetailsBankDeposit from "./bank-deposit/bank-deposit.module";
import ShiftDetailsKeyAccounts from "./key-accounts/key-accounts.module";
import ShiftDetailsVarianceAdjustment from "./variance-adjustment/variance-adjustment.module";

const CashNonCashTab = (props) => {
  const {
    loadingShift,
    shift,
    safeDrop,
    setSafeDrop,
    employees,
    setEmployees,
    pageMode,
    employeesToPay,
    setEmployeesToPay,
    variance,
    setVariance,
    refetchShift,
  } = props;

  return (
    <>
      <Loader open={loadingShift} />
      {shift && !loadingShift && (
        <div className={styles.container}>
          <ShiftDetailsNonSaleTransactions shift={shift} />
          <ShiftDetailsNonCashSummary
            shift={shift}
            refetchShift={refetchShift}
            pageMode={pageMode}
          />
          <ShiftDetailsCashTransaction shift={shift} />
          <ShiftDetailsVarianceAdjustment shift={shift} />
          <ShiftDetailsPromoSummary shift={shift} />
          <ShiftDetailsExpense shift={shift} />
          <ShiftDetailsCashOnHand
            shift={shift}
            safeDrop={safeDrop}
            setSafeDrop={setSafeDrop}
            pageMode={pageMode}
          />
          <ShiftDetailsNetCashSummary
            shift={shift}
            pageMode={pageMode}
            employees={employees}
            setEmployees={setEmployees}
            safeDrop={safeDrop}
            employeesToPay={employeesToPay}
            setEmployeesToPay={setEmployeesToPay}
            variance={variance}
            setVariance={setVariance}
          />
          <ShiftDetailsBankDeposit shift={shift} />
          <ShiftDetailsKeyAccounts shift={shift} />
        </div>
      )}
    </>
  );
};

export default CashNonCashTab;
